var React = require('react');

function Clock (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M10 2H14M12 14L15 11","stroke":"#262AC5","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M12 22C16.4183 22 20 18.4183 20 14C20 9.58172 16.4183 6 12 6C7.58172 6 4 9.58172 4 14C4 18.4183 7.58172 22 12 22Z","stroke":"#262AC5","strokeWidth":"2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

Clock.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = Clock;

Clock.default = Clock;
